import { isValidUsername, isValidUsernameErrorMessage } from '@core/shared/model';
import { isEmail } from 'class-validator';
export const usernameOrEmailUserItemValidator = {
  validate: (value, args, c) => {
    const nameIsEmail = c.get('users.usernameIsEmail', false);
    const validationErrorMsg = nameIsEmail ? 'Bitte geben Sie eine gültige E-Mail-Adresse an.' : isValidUsernameErrorMessage;
    return (nameIsEmail ? isEmail(value) : isValidUsername(value)) || validationErrorMsg;
  }
};